module.exports = __webpack_public_path__ + "3a5e0ec5f751c1dfa9a370676ae352e9.mp3";